import React from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../resources/ResourcesStore";
import { injectFromApp } from "../inject";
import type { ICookieSettingsStore } from "./CookieSettingsStore";
import parser from "html-react-parser";

interface ICookieBannerComponentProps {
    resourcesStore?: IResourcesStore;
    cookieSettingsStore?: ICookieSettingsStore;
}

@injectFromApp<ICookieBannerComponentProps>((stores) => ({
    resourcesStore: stores.resourcesStore,
    cookieSettingsStore: stores.cookieSettingsStore,
}))

@observer
export class CookieBannerComponent extends React.Component<ICookieBannerComponentProps> {
    private readonly acceptAll = (): void => {
        const { cookieSettingsStore } = this.props;
        cookieSettingsStore!.acceptAll();
    };

    private readonly acceptNecessary = (): void => {
        const { cookieSettingsStore } = this.props;
        cookieSettingsStore!.acceptNecessary();
    };

    private readonly close = (): void => {
        const { cookieSettingsStore } = this.props;
        cookieSettingsStore!.close();
    };

    render() {
        const { resourcesStore, cookieSettingsStore } = this.props;
        const { resources } = resourcesStore!;
        const { showCookieBanner } = cookieSettingsStore!;

        if (!showCookieBanner) return;

        const { acceptedAllCookies, acceptedNecessaryCookies } = cookieSettingsStore!;

        const classNameAllCookies = acceptedAllCookies ? "green" : "silent border";
        let classNameNecessaryCookies: string = "";
        if (acceptedNecessaryCookies) {
            classNameNecessaryCookies = "green";
        } else {
            classNameNecessaryCookies = acceptedAllCookies ? "silent border" : "green";
        }
        
        return (
            <div id={"cookie-banner"}>
                <div className={"content"}>
                    <button onClick={this.close} className={"close"}>
                        &nbsp;
                    </button>
                    <h2 className={"title"}>{resources.CookiesTitle}</h2>
                    <p className={"info"}>{parser(resources.CookiesInfo.replace("{0}", "/POW4/Legal"))}</p>
                    <div className={"buttons"}>
                        <button className={classNameAllCookies} onClick={this.acceptAll}>
                            {resources.AcceptAllCookies}
                        </button>
                        <button className={classNameNecessaryCookies} onClick={this.acceptNecessary}>
                            {resources.NecessaryCookiesOnly}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
